import {AfterViewInit, Component, OnDestroy, OnInit, Input, HostListener, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {CommonService} from '../../../../../../core/services/common.service';
import {Message} from '../../../../../../core/class/message';
import {MatDialog, MatPaginator, MatTableDataSource} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {NotificationService} from '../../../../../../core/services/notification.service';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {EditAccountBrandnameComponent} from '../../../../../../shared/components/edit-account-brandname/edit-account-brandname.component';
import {BranchNameService} from '../../../../../../core/services/brand-name.service';

interface Item {
    name: string;
    isActive: boolean;
    type: string;
    username: string;
    password: string;
    cpCode: string;
    serviceId: string;
}

@Component({
    selector: 'app-enterprise-config-enterprise',
    templateUrl: './enterprise-notification-enterprise.component.html',
    styleUrls: ['./enterprise-notification-enterprise.component.scss']
})
export class EnterpriseNotificationEnterpriseComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @BlockUI() blockUI!: NgBlockUI;
    displayedColumns: string[] = [
        'stt',
        'name',
        'username',
        'type',
        'action'
    ];
    paginate = {
        currentPage: 0,
        pageSize: 10,
        totalRow: 0,
        totalPage: 0,
        totalPageArray: [],
        no: []
    };
    dataSource: MatTableDataSource<any>;
    public mediaBreakpoint: any;
    public SCREEN_SIZE = SCREEN_SIZE;
    items: Item[] = [];
    brandNameConfig: Item[] = [];
    selectedItems: Item;
    originalSelectItems: Item;
    searchTerm = '';
    originalItems = [];
    @ViewChild('searchInput', {static: false}) searchInput!: ElementRef;

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator | undefined;

    constructor(public brandNameService: BranchNameService,
                public commonService: CommonService,
                private toastr: ToastrService,
                public message: Message,
                private notificationService: NotificationService,
                private cdr: ChangeDetectorRef,
                private dialog: MatDialog,
    ) {
        super(commonService, message);
    }

    ngOnInit() {
        this.notificationService.subscribeErrorService();

        this.loadData(0, 10);
    }

    ngOnDestroy() {
        this.notificationService.unsubscribeErrorService();
    }

    onItemSelect(event: any) {
        const selectedItem = event.value;
        if (selectedItem) {
            this.callApi(selectedItem.name, selectedItem.type);
        }
    }

    counter(i: number, from: number): any {
        return new Array(i).fill(0).map((x, i) => i + from);
    }


    loadData(page: number = 0, pageSize: number = 10) {
        this.brandNameService.getBranchName().subscribe({
            next: res => {
                if (res && res.success && Array.isArray(res.data)) {
                    this.items = res.data.map(item => ({
                        name: item.name,
                        isActive: item.isActive,
                        type: item.type,
                        username: item.username,
                        password: item.password,
                        cpCode: item.cpCode,
                        serviceId: item.serviceId,
                    }));
                    this.brandNameConfig = this.items.filter(item => item.type === 'BRAND_NAME_SMS');
                    this.paginate.totalRow = this.brandNameConfig.length;
                    this.paginate.totalPage = Math.ceil(this.paginate.totalRow / this.paginate.pageSize);
                    this.paginate.totalPageArray = this.counter(Math.ceil(this.paginate.totalRow / pageSize), 1);
                    this.paginate.currentPage = page;
                    this.paginate.no = this.counter(pageSize, this.paginate.currentPage * pageSize + 1);

                    this.dataSource = new MatTableDataSource(this.brandNameConfig.slice(page * pageSize, (page + 1) * pageSize));
                    this.dataSource.paginator = this.paginator;
                    this.originalItems = [...this.items];
                    const activeItems = this.items.filter(item => item.isActive);
                    this.selectedItems = (activeItems.length > 0) ? activeItems[0] : null;
                    this.originalSelectItems = (activeItems.length > 0) ? activeItems[0] : null;
                } else {
                    this.toastr.error(this.message.getMessage('brand_name.load_data_fail'));
                }
            },
            error: err => {
                this.toastr.error(this.message.getMessage('brand_name.load_data_fail'));
            }
        });
    }

    callApi(selectedItem: string, type: string) {
        this.brandNameService.activeBranchName(selectedItem, type).subscribe({
            next: res => {
                if (res && res.success) {
                    this.loadData(0, 10);
                    this.toastr.success(this.message.getMessage('brand_name.updated_success'));
                } else {
                    this.toastr.error(this.message.getMessage('brand_name.updated_fail'));
                }
            },
            error: err => {
                this.toastr.error(this.message.getMessage('brand_name.updated_fail'));
            }
        });
    }

    searchBrandName() {
        if (!this.searchTerm || this.searchTerm.trim() === '') {
            this.items = [...this.originalItems];
        } else {
            this.items = this.originalItems.filter(item =>
                item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
            );
        }
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        const dropdown = document.querySelector('mat-select');
        if (dropdown && !dropdown.contains(event.target as Node)) {
            if (!this.selectedItems) {
                this.selectedItems = this.originalSelectItems;
            }
        }
        this.searchTerm = '';
        this.selectedItems = this.originalSelectItems;
        this.items = this.originalItems;
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault();

            this.searchTerm = '';
            this.selectedItems = this.originalSelectItems;
            this.items = this.originalItems;
        }
    }

    focusSearchInput() {
        setTimeout(() => {
            if (this.searchInput) {
                this.searchInput.nativeElement.focus();
            }
        }, 0);
    }

    editBrandName(branchName: any) {
        const dialogRef = this.dialog.open(EditAccountBrandnameComponent, {
            width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '40%',
            maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '70vw',
            panelClass: 'edit-account',
            data: branchName
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadData(0, 10);
            }
        });
    }


    ngAfterViewInit() {

    }
}
